import React from 'react';
import './Article.scss';
import {NavLink as Link} from 'react-router-dom';
import ImageResponsive from './ImageResponsive';

class Article extends React.Component {
  handleFieldChange(e) {
    const newData = {
      article: {}
    };

    if (e.target.type === 'checkbox') {
      newData.article[e.target.name] = {
        $set: e.target.checked
      };
    } else {
      newData.article[e.target.name] = {
        $set: e.target.value
      };
    }
  }

  render() {
    const article = this.props.article;
    const image = article.listImage;
    const title = article.title;
    const summary = article.summary;


    let status = {
      text: 'Ikke publisert',
      class: 'alert-warning'
    };
    if (article.published === true) {
      status = {
        text: 'Publisert',
        class: 'alert-success'
      };
    }

    return (
      <div className="contentful-article">
        <div className="contentful-article-toolbar">

          <div className={`contentful-article-header ${status.class}`} title={status.text}>
            <strong>{title}</strong>
            <p>{summary}</p>
          </div>


          {image && Boolean(!this.props.onSelect) &&
          <div>
            <ImageResponsive
              className="img-rounded"
              src={image.url}
              width={600}
              height={300}
              fit="pad"
            >
            </ImageResponsive>
          </div>
          }

          <div className="contentful-article-actions text-right">
            {Boolean(this.props.onSelect) &&
              <a
                className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                onClick={() => this.props.onSelect(article)}
              >
                Velg
              </a>
            }
            {Boolean(this.props.allowEdit) && Boolean(this.props.onRemove) &&
              <span>&nbsp;</span>
            }
            {Boolean(this.props.allowEdit) &&
              <Link
                to={`/articles/${article.id}`}
                key={article.id}
                className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i> Endre
              </Link>
            }
            {Boolean(this.props.allowEdit) && Boolean(this.props.onRemove) &&
              <span>&nbsp;</span>
            }
            {this.props.context !== 'Articles' && Boolean(this.props.onRemove) &&
              <a
                className={`${this.props.disabled ? 'disabled ' : ''}btn btn-default`}
                onClick={() => this.props.onRemove(article)}
              >
                <i className="fa fa-times" aria-hidden="true"></i> Fjern
              </a>
            }
          </div>
        </div>
      </div>
    );
  }
}

Article.defaultProps = {
  disabled: false,
  context: null
};

export default Article;
